import { statusStepBg, filterPipeline } from '../utils/statusUtils'
import { useProjectConfig } from '../lib/appContext'

interface StatusPipelineProps {
  status: string
  onChange?: (id: string) => void
  compact?: boolean
}

export default function StatusPipeline({ status, onChange }: StatusPipelineProps) {
  const { hiddenStatuses, statuses } = useProjectConfig()
  const pipeline   = filterPipeline(hiddenStatuses, statuses)
  const currentIdx = pipeline.findIndex(s => s.id === status)

  return (
    <div className="pipeline" style={{ gridTemplateColumns: `repeat(${pipeline.length}, 1fr)` }}>
      {pipeline.map((step, idx) => {
        const done   = idx <= currentIdx
        const active = idx === currentIdx
        return (
          <button
            key={step.id}
            className={`pipeline-step${done ? ' filled' : ''}${active ? ' active' : ''}`}
            style={done ? { background: statusStepBg(step) } : {}}
            onClick={() => onChange?.(step.id)}
            aria-current={active ? 'step' : undefined}
            title={step.label}
          >
            <span className="pipeline-step-nr">
              {String(idx + 1).padStart(2, '0')}
            </span>
            <span className="pipeline-step-label">{step.kort}</span>
          </button>
        )
      })}
    </div>
  )
}
